import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash } from "lucide-react";
import { Button, type ButtonProps } from "./button";

interface DeleteDialogProps<T> {
  row: T;
  message: string;
  onDelete?: (id: number | string) => void;
  /** Texto exibido ao lado do ícone da lixeira. Sem ele, o botão é só o ícone. */
  label?: string;
  size?: ButtonProps["size"];
  /** Quando informado, o diálogo é controlado e não renderiza o botão gatilho. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DeleteDialog = <T extends Record<string, any>>({
  row,
  onDelete,
  message,
  label,
  size = "sm",
  open,
  onOpenChange,
}: DeleteDialogProps<T>) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {open === undefined && (
        <AlertDialogTrigger asChild>
          <Button
            size={size}
            className="dark:bg-danger bg-danger text-white hover:opacity-90 dark:hover:text-foreground dark:hover:opacity-90"
            disabled={row.id === undefined}
          >
            <Trash />
            {label}
          </Button>
        </AlertDialogTrigger>
      )}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="dark:bg-foreground bg-foreground text-background dark:hover:text-background dark:hover:opacity-90">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            className="bg-danger text-background dark:text-white dark:hover:bg-danger dark:hover:opacity-90"
            onClick={async () => {
              if (onDelete) {
                await onDelete(row.id);
              }
            }}
          >
            Confirmar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { DeleteDialog };
